import { useAuthStore } from '@/stores/auth';

export function useAuth() {
  const { 
    user, 
    accessToken,
    isAuthenticated, 
    isInitialized,
    isLoading, 
    error, 
    login, 
    logout, 
    initializeAuth,
    clearError,
    setUser 
  } = useAuthStore();

  return {
    user,
    accessToken,
    isAuthenticated,
    isInitialized,
    isLoading,
    error,
    login,
    logout,
    initializeAuth,
    clearError,
    setUser,
  };
}
